import React, { useState, useRef, useEffect, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { FaSearch, FaToggleOn, FaToggleOff, FaPen, FaStar, FaHistory, FaUser } from "react-icons/fa";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import CommonContainer from "../Container/CommonContainer";
import toast from "react-hot-toast";
import * as PartnerUserService from '../../Services/Partner/PartnerUserService'
import { ActivateDeactivateUser } from '../../Services/User/UserService'
import 'react-datepicker/dist/react-datepicker.css';
import { store } from "../../Store/store";
import PartnerUserAddEditComponent from "./PartnerUserAddEditComponent";
import '../../Common/CommonStyles.css'
import CommonPagination from "../../Common/CommonPagination";
import "./PartnerUserListComponent.css"
import CommonRightPanel from "../../Common/CommonRightPanel";
import { useAddStaff, useEditStaff } from "../../Common/CommonAccessFile";
import { GetAccessControlMasterList_ForPartnerAdmin } from "../../Services/User/UserService";

const PartnerUserListComponent = () => {
  const accessToAddStaff = useAddStaff();
  const accessToEditStaff = useEditStaff();

  const [newPartnerUserShow, setNewPartnerUserShow] = useState(false);
  const userPartnerCode = useSelector((state) => state.userData.Partner_Code);

  const [filteredPartnerUserList, setFilteredPartnerUserList] = useState([]);
  const [ActiveRoleList, setActiveRoleList] = useState([]);

  const { reset } = useForm();

  const [selectedPartnerUser, setSelectedPartnerUser] = useState({});
  // const [SearchLoading, setSearchLoading] = useState(false);
  const selectedSearchPartnerUser = useRef();

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50); // Set number of items per page

  const indexOfLastPartnerUser = currentPage * itemsPerPage;
  const indexOfFirstPartnerUser = indexOfLastPartnerUser - itemsPerPage;
  const currentPartnerUsers = filteredPartnerUserList.slice(indexOfFirstPartnerUser, indexOfLastPartnerUser);

  const [accessControlMasterList, setAccessControlMasterList] = useState([]);

  const partnerUserInfo = store.getState();

  const fetchPartnerUserList = useCallback(() => {
    //debugger;
    PartnerUserService.GetUniversalFilterPartnerUserData(userPartnerCode, "")
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          setFilteredPartnerUserList(data.Data);
        }
      })
      .catch(() => toast.error("Something went wrong."));
  }, []);

  useEffect(() => {
    GetPartnerUserDependedFeildDataList();
    fetchPartnerUserList();
  }, [fetchPartnerUserList]);

  const fetchUniversalFilterPartnerUserData = () => {

    if (!selectedSearchPartnerUser.current.value) {
      window.location.reload()
      return;
    }
    PartnerUserService.GetUniversalFilterPartnerUserData(userPartnerCode, selectedSearchPartnerUser.current.value)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          setFilteredPartnerUserList(data.Data);
        }
        else {
          setFilteredPartnerUserList([]);
        }
      })
      .catch(() => toast.error("Something went wrong."));
  };

  const handleViewPartnerUserDetailById = (partnerUserId) => {
    //debugger;
    PartnerUserService.GetPartnerUserDetailById(partnerUserId).then(({ data }) => {
      if (data.IsSuccess) {
        setSelectedPartnerUser(data.Data);
        setNewPartnerUserShow(true);
      } else {
        setSelectedPartnerUser({})
        // toast.error("No Data found for selected range");
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() => { }
        //setLoading(false)
      );
  };


  const handleStaffSendPassword = (staffId) => {
    //debugger;
    PartnerUserService.SendPassword(staffId).then(({ data }) => {
      if (data.IsSuccess) {
        toast.success("Credentials sent successfully")
      } else {
        toast.error(data.ResponseMessage)
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() => { }
        //setLoading(false)
      );
  };

  const handleNewPartnerUserClose = () => {
    reset();
    setSelectedPartnerUser([]);
    setNewPartnerUserShow(false)
  };

  const onSubmit = (data) => {
    data.UserRightsDet = accessControlMasterList;
    //debugger;
    //Update User
    if (selectedPartnerUser?.UserId) {
      data.UserId = selectedPartnerUser?.UserId;
      data.Partner_Code = userPartnerCode;
      PartnerUserService.UpdatePartnerUser(data)
        .then(({ data }) => {
          if (data.IsSuccess) {
            fetchPartnerUserList();
            toast.success("Partner staff updated successfully!");
            handleNewPartnerUserClose();
          } else {
            toast.error(data.ResponseMessage + " with emailid " + data.Data.EmailId);
          }
        })
        .catch(() => toast.error("Something went wrong during update."))
        .finally(() => { });
    }
    //Create User
    else {
      data.Partner_Code = userPartnerCode;
      PartnerUserService.CreatePartnerUser(data)
        .then(({ data }) => {
          //debugger;
          if (data.IsSuccess) {
            fetchPartnerUserList();
            toast.success("Partner staff saved successfully!");
            handleNewPartnerUserClose();
          } else {
            toast.error(data.ResponseMessage);
          }
        })
        .catch(() => toast.error("Something went wrong during creation."))
        .finally(() => { });
    }
  };

  const GetPartnerUserDependedFeildDataList = () => {
    PartnerUserService.GetPartnerAdminRoleList().then(({ data }) => {
      //debugger;
      if (data.IsSuccess) {
        setActiveRoleList(data.Data.RoleList)
      } else {
        setActiveRoleList([]);
      }
    })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() => { }
        //setLoading(false)
      );
  };

  // const handleActivateDeActivatePartnerUser = (rec) => {

  //   ActivateDeactivateUser(rec.UserId, !rec.IsActive).then(data => {
  //     if (data.data.IsSuccess) {
  //       const message = rec.IsActive ? "Partner staff DeActivated Successfully" : "Partner staff Activated Successfully";
  //       toast.success(message);
  //       fetchPartnerUserList();
  //     } else {
  //       toast.error("Somthing went wrong");
  //     }
  //   }).catch(error => {
  //     toast.error("Somthing went wrong");
  //   })

  // };

  const handleActivateDeActivatePartnerUser = (rec) => {

    PartnerUserService.ActivateDeactivatePartnerUser(rec.UserId, !rec.IsActive).then(data => {
      if (data.data.IsSuccess) {
        const message = rec.IsActive ? "Partner staff DeActivated Successfully" : "Partner staff Activated Successfully";
        toast.success(message);
        fetchPartnerUserList();
      } else {
        toast.error(data.data.ResponseMessage)
      }
    }).catch(error => {
      toast.error("Somthing went wrong");
    })

  };

  const [showRightPanel, setShowRightPanel] = useState(false);
  const [staffLoginHistory, setStaffLoginHistory] = useState([]);

  const fetchStaffLoginHistory = (emailid) => {
    PartnerUserService.GetStaffLoginHistory(emailid)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          setStaffLoginHistory(data.Data)
          setShowRightPanel(true);
        } else {
          setStaffLoginHistory([]);
        }
      })
      .catch(() =>
        toast.error("Something went wrong.")
      ).finally(() => { }
        //setLoading(false)
      );
  }

  const handleShowLoginLog = (rec) => {
    fetchStaffLoginHistory(rec.EmailId);
  }

  const fetchAccessControlMasterList = (userid) => {

    GetAccessControlMasterList_ForPartnerAdmin(userid)
      .then(data => {
        //debugger;
        if (data.data.IsSuccess) {
          setAccessControlMasterList(data.data.Data)
        }
        else {
          setAccessControlMasterList();
        }
      })
      .catch(error => {
        toast.error("Something went wrong")
      })
      .finally(() => {

      })
  }

  return (
    <>
      {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
      <CommonContainer
        icon={<FaUser size={20} />}
        heading="Partner Staff List"
        buttonText={
          accessToAddStaff && (<span className="d-inline-flex align-items-center">
            <span className="d-none d-sm-inline">Add Partner Staff</span>
          </span>)
        }
        onButtonClick={() => {
          reset(); setSelectedPartnerUser([]); setNewPartnerUserShow(true); fetchAccessControlMasterList();
        }}>

        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="d-flex align-items-center gap-2">
          </div>
          <div className="search-box" style={{ position: "relative", width: "320px" }}>
            <input
              type="text"
              className="form-control"
              placeholder="Search by Staff Name, Email, Mobile"
              ref={selectedSearchPartnerUser}
              style={{
                paddingRight: "35px",
                borderRadius: "5px",
                border: "1px solid #ddd",
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchUniversalFilterPartnerUserData();
                }
              }}
            />
            <button
              type="button"
              className="btn custom-sumbitbtn d-flex align-items-center justify-content-center"
              style={{
                padding: '5px',
                position: "absolute",
                right: "0px",
                height: "35px",
                width: "45px",
                top: "50%",
                borderTopLeftRadius: "0",
                borderBottomLeftRadius: "0",
                transform: "translateY(-50%)",
              }}
              onClick={fetchUniversalFilterPartnerUserData}
            >
              <FaSearch />
            </button>

          </div>
        </div>
        <div>
          <div className="table-responsive" >
            <table className="table table-bordered custom-table" >
              <thead>
                <tr>
                  <th style={{ width: "25%" }}> Partner Staff Name </th>
                  <th> Email Id </th>
                  <th> Mobile No </th>
                  <th> Role Name</th>
                  <th> Active </th>
                  <th> Action </th>
                </tr>
              </thead>
              <tbody>
                {
                  currentPartnerUsers.length > 0 ? (
                    currentPartnerUsers.map((rec, index) => (
                      <tr key={index} >
                        <td>{rec.Is_Partner_Primary_User && <FaStar className="text-warning me-1" title="Primary User" />} {rec.FirstName} {rec.LastName} </td >
                        <td> {rec.EmailId} </td>
                        <td> {rec.MobileNo} </td>
                        <td> {rec.Role_Name} </td>
                        {/* {accessToEditStaff &&
                          <td>
                            {rec.IsActive ? <FaToggleOn className="cursor-pointer" title="Deactivate PartnerUser" onClick={() => handleActivateDeActivatePartnerUser(rec)} color="green" size={16} /> : <FaToggleOff className="cursor-pointer" onClick={() => handleActivateDeActivatePartnerUser(rec)} title="Activate PartnerUser" color="red" size={16} />}
                          </td>
                        } */}
                        <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                          {rec.IsActive ? (
                            <FaToggleOn
                              className={accessToEditStaff ? "cursor-pointer" : "cursor-not-allowed opacity-50"}
                              title={accessToEditStaff ? "Deactivate PartnerUser" : "Edit access is disabled"}
                              onClick={() => {
                                if (!accessToEditStaff) return; // prevent click if no access
                                handleActivateDeActivatePartnerUser(rec);
                              }}
                              color={accessToEditStaff ? "green" : "gray"}
                              size={16}
                            />
                          ) : (
                            <FaToggleOff
                              className={accessToEditStaff ? "cursor-pointer" : "cursor-not-allowed opacity-50"}
                              title={accessToEditStaff ? "Activate PartnerUser" : "Edit access is disabled"}
                              onClick={() => {
                                if (!accessToEditStaff) return; // prevent click if no access
                                handleActivateDeActivatePartnerUser(rec);
                              }}
                              color={accessToEditStaff ? "red" : "gray"}
                              size={16}
                            />
                          )}
                        </td>
                        <td>
                          {accessToEditStaff && (<FaPen color="green" className="mr-2 cursor-pointer" onClick={() => {
                            handleViewPartnerUserDetailById(rec.UserId);
                            fetchAccessControlMasterList(rec.UserId);
                          }} title="Edit Partner Staff" />)}
                          <FaHistory color="green" className="mr-2 cursor-pointer" onClick={() => handleShowLoginLog(rec)} title="Open Right Panel" />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="9" className="text-center" > No Partner Staff found </td></tr >
                  )}
              </tbody>
            </table>
          </div>

          {filteredPartnerUserList.length > itemsPerPage ? (
            <CommonPagination
              pageList={filteredPartnerUserList}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
            />
          ) : null}

        </div>
        {newPartnerUserShow && (
          <>
            <PartnerUserAddEditComponent
              onSubmit={onSubmit}
              handleNewPartnerUserClose={handleNewPartnerUserClose}
              selectedPartnerUser={selectedPartnerUser}
              partnerUserInfo={partnerUserInfo}
              ActiveRoleList={ActiveRoleList}
              accessControlMasterList={accessControlMasterList}
              setAccessControlMasterList={setAccessControlMasterList}
            />
          </>
        )}
      </CommonContainer >

      {showRightPanel && (
        <CommonRightPanel
          isOpen={showRightPanel}
          onClose={() => setShowRightPanel(false)}
          data={staffLoginHistory}
        />
      )}
    </>
  );
};

export default PartnerUserListComponent;